import { hosts } from "../../../yoello-lib/modules/host/Hosts";
import { ESignupStages } from "../types";



export const BackStages: Record<string, Record<string, string>> = {
    [hosts.partners]: {
        [ESignupStages.SUBSCRIPTION]: ESignupStages.VENUE
    }
}